<template>
    <div class="widget-action-bar">
        <div>
            <transition-group name="action-bar-transition">
                <div v-if="actions.length">
                    <button
                        v-for="(button, index) in actions"
                        :key="index"
                        :class="{ secondary: button.secondary }"
                        :disabled="button.loading"
                        class="button-action"
                        :type="button.buttonType ?? 'button'"
                        :data-testid="button.testId || `widget-action-button-${index}`"
                        @click="button.callback"
                    >
                        <div class="button-action-content">
                            {{ button.label }}
                        </div>
                    </button>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Action } from '@/types'

type PlainAction = Action & {
    buttonType?: 'reset' | 'submit' | 'button'
}

defineProps<{
    actions: PlainAction[]
}>()
</script>

<style lang="sass" scoped>
.widget-action-bar
    transition: ease-in-out all .3s
    position: relative
    z-index: 10
    background: var(--tl-widget-background-color, var(--color-white, #fff))
    padding-top: 12px

    .button-action
        margin-top: 14px
        &:first-child
            margin-top: 0

@import "widget-components/components/ActionButton/ActionButton.sass"
</style>
